import styled from "@emotion/styled";

const Container = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const Banner = styled.div`
  background-color: #1890ff;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
`;

const FloatingImage = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`;

export const QRCodeButton = () => {
  return (
    <Container>
      <Banner>Toegang tot dit dashboard?</Banner>
      <FloatingImage src="/qr_demo_account_auth.png" alt="QR Code" />
    </Container>
  );
};
